<template>
  <p class="date">
    <span
      v-if="label"
      class="font-bold"
    >
      {{ label }}:
    </span> {{ date | formatDateDistance }}
  </p>
</template>

<script>
export default {
  name: "CampaignListDate",
  props: {
    date: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    }
  }
};
</script>

<style scoped>
.date {
  @apply text-xs text-grey-darker m-0;

  @screen sm {
    @apply text-sm;
  }
}
</style>
